import { Button, Form, Input, SectionTitle, Link, Select } from 'src/components'
import { loginType, registerZodSchema } from 'src/types'
import { currencies, ROUTE_HOME } from 'src/lib'
import { Logo, Right } from 'src/assets'
import { t } from 'i18next'

const RegisterPage = () => {
  const handleSubmit = (data: loginType) => {
    console.log(data, 'todo add functionality when BE is ready')
  }

  return (
    <div className='w-full h-full flex-column justify-center items-center gap-[30px] p-[50px] bg-light-gray'>
      <Link to={ROUTE_HOME}>
        <Logo className='h-[80px] w-[80px]' />
      </Link>
      <div className='p-[40px] bg-mid w-[400px] rounded-sm transition-all duration-500 hover:scale-105 bg-white'>
        <SectionTitle
          title={t('global.register')}
          subtitle={t('login.welcome.subtitle')}
          textPosition='left'
        />
        <Form
          className='gap-[20px] flex-column'
          onSubmit={handleSubmit}
          schema={registerZodSchema}
        >
          <div className='w-full flex gap-[10px]'>
            <Input name='firstName' label={t('global.firstName')} />
            <Input name='lastName' label={t('global.lastName')} />
          </div>
          <Input name='email' label={t('global.email')} />
          <Input name='password' type='password' label={t('global.password')} />
          <Input
            name='confirmPassword'
            type='password'
            label={t('global.confirm.password')}
          />
          <Button size='m' type='submit' icon={<Right />}>
            {t('global.register')}
          </Button>
        </Form>
      </div>
      <div className='flex gap-[10px] text-dark-gray base-normal'>
        {t('register.already.have.account')}
        <Link className='underline text-black' to='/login'>
          {t('global.login')}
        </Link>
      </div>
    </div>
  )
}
export default RegisterPage
